export const invalidCompany = {
  title: 'Wrong company',
  description: 'Please, check your company or contact our manager',
  button: 'Back to Home',
};
